import { render, staticRenderFns } from "./DishEvaluateIndex.vue?vue&type=template&id=f5985d7a&scoped=true"
import script from "./DishEvaluateIndex.vue?vue&type=script&lang=js"
export * from "./DishEvaluateIndex.vue?vue&type=script&lang=js"
import style0 from "./DishEvaluateIndex.vue?vue&type=style&index=0&id=f5985d7a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5985d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5985d7a')) {
      api.createRecord('f5985d7a', component.options)
    } else {
      api.reload('f5985d7a', component.options)
    }
    module.hot.accept("./DishEvaluateIndex.vue?vue&type=template&id=f5985d7a&scoped=true", function () {
      api.rerender('f5985d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/evaluate/DishEvaluateIndex.vue"
export default component.exports